import React from "react";

export default function RegisterButton({ className, value, handlePress }) {
  return <button className={className} onClick={handlePress} >{value}</button>;
}
